import React, { cloneElement } from 'react';
import { motion } from 'framer-motion';
import { Globe, Users, Shield, Landmark, CheckCircle2, Leaf, BookOpen } from 'lucide-react';
export const About = () => {
  return <main className="pt-24" data-id="element-93" data-mp="29keuhylojnqn">
      {/* Hero Section */}
      <section className="bg-brand-navy py-24 text-white relative overflow-hidden" data-id="element-94" data-mp="29hslduj5506b">
        <div className="absolute inset-0 opacity-10" data-id="element-95" data-mp="2eizxg5sbglis">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80')] bg-cover bg-center" data-id="element-96" data-mp="32819e30cyest" />
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-97" data-mp="2sadbj47ggr6f">
          <span className="text-brand-gold font-bold tracking-widest uppercase text-sm mb-6 block" data-id="element-98" data-mp="1lukh9fxg7x5v">
            About Consilium
          </span>
          <h1 className="text-5xl md:text-7xl font-display mb-8" data-id="element-99" data-mp="1uiblqgmvvbob">
            Global Expertise. <br data-id="element-100" data-mp="1pk0dgac8l987" />
            <span className="italic" data-id="element-101" data-mp="1pkjkgw0cmd7g">Institutional</span> Quality.
          </h1>
          <p className="text-xl text-white/70 max-w-2xl leading-relaxed" data-id="element-102" data-mp="23j9iqeywmixe">
            Consilium Advisory is a premier multidisciplinary firm delivering
            strategic advice, disciplined execution, and lasting partnerships to
            a global clientele.
          </p>
        </motion.div>
      </section>

      {/* Philosophy */}
      <section className="py-24 bg-brand-warm-white" data-id="element-103" data-mp="28fqgm0vwobno">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-7xl mx-auto px-6" data-id="element-104" data-mp="2m7wo6ykztabi">
          <div className="grid lg:grid-cols-2 gap-20 items-center" data-id="element-105" data-mp="1oumtm5tlm6re">
            <div data-id="element-106" data-mp="1owhczfp81qtd">
              <h2 className="text-4xl font-display text-brand-navy mb-8" data-id="element-107" data-mp="1ostjggjs14en">
                Our Philosophy
              </h2>
              <div className="space-y-6 text-brand-charcoal/70 text-lg leading-relaxed" data-id="element-108" data-mp="1xut19b2m8cin">
                <p data-id="element-109" data-mp="22lrjwhb2tmp2">
                  We believe that complex financial decisions require more than
                  just technical expertise—they require strategic foresight and
                  a deep understanding of the global economic landscape.
                </p>
                <p data-id="element-110" data-mp="2cmbontxt19c1">
                  Our firm was founded on the principles of integrity,
                  accountability, and disciplined execution. We don't just
                  advise; we partner with our clients to drive sustainable
                  growth and long-term value.
                </p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-6" data-id="element-111" data-mp="r62vrmm36hmo">
              {[{
              title: 'Integrity',
              icon: <Shield data-id="element-112" data-mp="joy35bwkvcfb" />
            }, {
              title: 'Expertise',
              icon: <Globe data-id="element-113" data-mp="evbtlslpnonq" />
            }, {
              title: 'Partnership',
              icon: <Users data-id="element-114" data-mp="9v7f284d5405" />
            }, {
              title: 'Execution',
              icon: <CheckCircle2 data-id="element-115" data-mp="12m7k8mefkdte" />
            }].map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: i * 0.1
            }} className="bg-white p-8 rounded-2xl shadow-sm border border-brand-navy/5 text-center" data-id="element-116" data-mp="12k4tg05gegnm" data-mpi={i}>
                  <div className="text-brand-gold mb-4 flex justify-center" data-id="element-117" data-mp="15updwo6dw7b9">
                    {cloneElement(item.icon, {
                  size: 32
                })}
                  </div>
                  <h4 className="font-heading font-bold text-brand-navy" data-id="element-118" data-mp="w4w3vrlw4094">
                    {item.title}
                  </h4>
                </motion.div>)}
            </div>
          </div>
        </motion.div>
      </section>

      {/* Initiatives */}
      <section className="py-24 bg-white" data-id="element-119" data-mp="1oss4h7ekycb6">
        <div className="max-w-7xl mx-auto px-6" data-id="element-120" data-mp="1aubp6s2njdhf">
          <div className="text-center mb-16" data-id="element-121" data-mp="1atisyl1bk6dj">
            <h2 className="text-4xl font-display text-brand-navy mb-4" data-id="element-122" data-mp="1euujqtvxixnb">
              Strategic Initiatives
            </h2>
            <p className="text-brand-charcoal/60 max-w-2xl mx-auto" data-id="element-123" data-mp="3viygn758reyy">
              Beyond advisory, we are committed to driving impact across the
              African continent through specialized platforms.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-124" data-mp="3s3wv78vdcs72">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="bg-brand-emerald p-12 rounded-3xl text-white" data-id="element-125" data-mp="3n1z6w0843779">
              <Leaf size={48} className="mb-8 text-brand-gold" data-id="element-126" data-mp="34aoh5me4h0gy" />
              <h3 className="text-3xl font-display mb-6" data-id="element-127" data-mp="3j2yogitjq6ks">
                Green Harvest Africa
              </h3>
              <p className="text-white/80 mb-8 leading-relaxed" data-id="element-128" data-mp="3e9e0ljlo2szb">
                Pioneering sustainable agricultural investment and
                transformation across the continent. We combine financial
                structure with operational excellence to drive food security and
                economic growth.
              </p>
              <button className="bg-white text-brand-emerald px-8 py-3 rounded-full font-bold text-sm uppercase tracking-widest hover:bg-brand-gold hover:text-white transition-all" data-id="element-129" data-mp="3fbin2njn36x9">
                Learn More
              </button>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="bg-brand-navy p-12 rounded-3xl text-white" data-id="element-130" data-mp="3p0scfvn3mbho">
              <BookOpen size={48} className="mb-8 text-brand-gold" data-id="element-131" data-mp="gm0iahf8h8xn" />
              <h3 className="text-3xl font-display mb-6" data-id="element-132" data-mp="gnutv54m7op2">Think Africa</h3>
              <p className="text-white/80 mb-8 leading-relaxed" data-id="element-133" data-mp="lja5rrj2baiu">
                An editorial and research platform focused on governance,
                policy, youth leadership, and international diplomacy. Shaping
                the future through intellectual rigor and strategic foresight.
              </p>
              <button className="bg-brand-gold text-white px-8 py-3 rounded-full font-bold text-sm uppercase tracking-widest hover:bg-white hover:text-brand-navy transition-all" data-id="element-134" data-mp="1wb9nc48cj3gt">
                Read Research
              </button>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Leadership */}
      <section className="py-24 bg-brand-warm-white" data-id="element-135" data-mp="1de8e277reh72">
        <div className="max-w-7xl mx-auto px-6" data-id="element-136" data-mp="1df01gur7d8m9">
          <div className="flex justify-between items-end mb-16" data-id="element-137" data-mp="18fdkqbc61a8p">
            <div data-id="element-138" data-mp="18gyehyqnop5i">
              <h2 className="text-4xl font-display text-brand-navy" data-id="element-139" data-mp="18hhz5n7oxrn8">
                Executive Leadership
              </h2>
              <p className="text-brand-charcoal/60 mt-4" data-id="element-140" data-mp="32smzahjkjlxt">
                Led by partners with deep experience in global finance and
                strategic consulting.
              </p>
            </div>
          </div>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-141" data-mp="2glu8bualsujm">
            {[{
            name: 'Emmanuel B. Ogunsalu',
            role: 'Managing Partner',
            image: 'https://cdn.magicpatterns.com/uploads/hcfjhxwmEvKg4UcofKbdKY/Emmanuel_B_Ogunsalu_2_(Final).jpg'
          }, {
            name: 'Executive Partner',
            role: 'Strategic Advisory',
            image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80'
          }, {
            name: 'Executive Partner',
            role: 'Capital Solutions',
            image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&q=80'
          }].map((leader, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: i * 0.1
          }} className="group" data-id="element-142" data-mp="3iay1dbj4pd7u" data-mpi={i}>
                <div className="aspect-[3/4] rounded-2xl overflow-hidden mb-6" data-id="element-143" data-mp="1qbjyf8lbws8w">
                  <img src={leader.image} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" alt={leader.name} data-id="element-144" data-mp="1lelbba031lk7" />
                </div>
                <h4 className="text-xl font-heading font-bold text-brand-navy" data-id="element-145" data-mp="1ucnhe3yob4ec">
                  {leader.name}
                </h4>
                <p className="text-brand-gold text-sm uppercase tracking-widest mt-1" data-id="element-146" data-mp="z19ygpgvsd">
                  {leader.role}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>
    </main>;
};